import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";

const MORE_ITEMS = [
  { label: "Services", icon: "✂️", path: "services" },
  { label: "Products", icon: "🛍️", path: "products" },
  { label: "Staff", icon: "👥", path: "staff" },
  { label: "Team", icon: "🏢", path: "team" },
  { label: "Payments", icon: "💳", path: "payments" },
  { label: "Settings", icon: "⚙️", path: "settings" },
];

interface MoreMenuProps {
  onClose: () => void;
}

export function MoreMenu({ onClose }: MoreMenuProps) {
  const { slug } = useParams<{ slug: string }>();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleNav = (path: string) => {
    navigate(`/${slug ?? ""}/${path}`);
    onClose();
  };

  const handleSignOut = async () => {
    onClose();
    await signOut();
    navigate("/login");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end md:hidden">
      {/* Backdrop */}
      <div
        className="absolute inset-0"
        style={{ background: "rgba(0,0,0,0.5)" }}
        onClick={onClose}
      />

      {/* Sheet */}
      <div
        className="relative w-full rounded-t-2xl pb-8"
        style={{ background: "var(--card-bg)", border: "1px solid var(--card-border)" }}
      >
        {/* Grab handle */}
        <div className="flex justify-center pt-3 pb-4">
          <div
            className="w-10 h-1 rounded-full"
            style={{ background: "var(--border)" }}
          />
        </div>

        {/* Menu items */}
        <ul>
          {MORE_ITEMS.map((item) => (
            <li key={item.path}>
              <button
                onClick={() => handleNav(item.path)}
                className="flex items-center gap-4 w-full px-6 py-4 text-sm font-medium transition-opacity hover:opacity-70"
                style={{ color: "var(--text)" }}
              >
                <span className="text-xl w-7 text-center">{item.icon}</span>
                {item.label}
              </button>
            </li>
          ))}
        </ul>

        {/* Divider */}
        <div
          className="mx-6 my-2"
          style={{ height: "1px", background: "var(--border)" }}
        />

        {/* Sign out */}
        <button
          onClick={handleSignOut}
          className="flex items-center gap-4 w-full px-6 py-4 text-sm font-medium transition-opacity hover:opacity-70"
          style={{ color: "#ef4444" }}
        >
          <span className="text-xl w-7 text-center">🚪</span>
          Sign out
        </button>
      </div>
    </div>
  );
}
